/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../store/useAuth";
import { StatiegeldProductsTable } from "./StatiegeldProductsTable";
import { useStatiegeldProducts } from "../../store/useStatiegeldProducts";
import Papa from "papaparse";
import { withAdminPermission } from "../../utils/HOC/withAdminPermission";

function StatigeldProductsScreen() {
  /** Refs */
  const fileInputRef = useRef(null);
  /** Hooks */
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    getStatiegeldProducts,
    addManyStatiegeldProduct,
    statiegeldProducts,
  } = useStatiegeldProducts();
  /** State */
  const [page /* setPage */] = useState(1);

  const handleFileUpload = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      Papa.parse(file, {
        header: true,
        complete: (result: any) => {
          const removeDuplicate = result.data.filter(
            (value: any, index: any, self: any) =>
              index ===
              self.findIndex(
                (t: any) => t.name === value.name && t.price === value.price
              )
          );
          addManyStatiegeldProduct(removeDuplicate);
        },
      });
    }
  };

  // const handleFileUpload = (event: any) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     Papa.parse(file, {
  //       header: true,
  //       complete: (result: any) => {
  //         let newData = [];
  //         for (let oldItem of result?.data) {
  //           if (!isNaN(Number(oldItem?.Gtin)) && oldItem?.Article !== "") {
  //             const productExist = statiegeldProducts.some(
  //               (product) => product?.gtin === oldItem?.Gtin
  //             );
  //             if (!productExist) {
  //               newData.push({
  //                 gtin: oldItem?.Gtin,
  //                 name: oldItem?.Article,
  //               });
  //             }
  //           }
  //         }
  //         const removeDuplicate = newData.filter(
  //           (value: any, index: any, self: any) =>
  //             index ===
  //             self.findIndex(
  //               (t: any) => t.name === value.name && t.price === value.price
  //             )
  //         );
  //         addManyStatiegeldProduct(removeDuplicate);
  //       },
  //     });
  //   }
  // };

  const addStatiegeldProduct = () => navigate("/add-statiegeld-product");

  const openFileUpload = () => {
    if (fileInputRef?.current) {
      //@ts-ignore
      fileInputRef?.current?.click();
    }
  };

  useEffect(() => {
    getStatiegeldProducts(page, 20);
  }, []);

  return (
    <div>
      <div className="flex w-full flex-col justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-1">
          Statiegeld Products
        </h1>
        {user?.user_role === 1 ? (
          <div className="flex flex-col sm:flex-row justify-end sm:items-center mb-4">
            <PrimaryButton
              onClick={addStatiegeldProduct}
              label="Add new Statiegeld Product"
              className="h-10 mb-1 sm:mb-0"
            />
            <input
              ref={fileInputRef}
              type="file"
              style={{ display: "none" }}
              accept=".csv"
              onChange={handleFileUpload}
            />
            <PrimaryButton
              onClick={openFileUpload}
              label="Add many Statiegeld Products"
              className="h-10 sm:ml-2 mb-2 sm:mb-0"
            />
          </div>
        ) : null}
      </div>

      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!statiegeldProducts?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Statiegeld product created yet.
          </p>
        ) : (
          <StatiegeldProductsTable />
        )}
      </div>
      {/* {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getArticles(page + 1, 20);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null} */}
    </div>
  );
}

export default withProtectedRoute(withAdminPermission(StatigeldProductsScreen));
